"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dateToEpochSeconds_1 = __importDefault(require("../utils/dateToEpochSeconds"));
const consts_1 = require("../consts");
function updateRecentSectionEvents(aggregatedStat, sessionEvent, { maxRecentStudyEvents = consts_1.MAX_NUMBER_OF_RECENT_SECTION_EVENTS } = {}) {
    const { session } = sessionEvent;
    const recentSectionEvents = aggregatedStat.recentSectionEvents
        ? [...aggregatedStat.recentSectionEvents]
        : [];
    if (recentSectionEvents.length === maxRecentStudyEvents) {
        recentSectionEvents.pop();
    }
    recentSectionEvents.unshift({
        timeFinished: (0, dateToEpochSeconds_1.default)(session.timeFinished),
        startingSectionProficiency: session.startingProficiency,
        endingSectionProficiency: session.endingProficiency,
        averageScore: session.averageScore
    });
    return recentSectionEvents;
}
exports.default = updateRecentSectionEvents;
